import { makeStyles } from '@material-ui/core';

export const DisclaimerStyle = makeStyles({
    root: {
        padding: '25px 0',
    },
});
